import tippy from "tippy.js";

const widgets = document.querySelectorAll(".js-dropdown-select");
[...widgets].forEach(widget => {
  widget.addEventListener("click", updateDropdown, false);
});

function updateDropdown({ target }) {
  const trigger = target.closest(".js-item");
  if (!trigger) return;

  const dropdownTrigger = trigger
    .closest(".js-dropdown-select")
    .querySelector(".js-trigger");
  dropdownTrigger.innerHTML = trigger.innerHTML;
  tippy.hideAll();
}

tippy("[data-dropdown]", {
  theme: "dropdown",
  trigger: "click",
  appendTo: "parent",
  placement: "bottom",
  maxWidth: "100%",
  role: "dropdown",
  interactive: true,
  animateFill: false,
	aria: {
		content: null,
		expanded: false,
	},
  zIndex: 9,
  duration: 0,
	offset: [0, 0],
	allowHTML: true,
  popperOptions: {
    modifiers: [{
			name: 'overrideStylesDropdown',
			enabled: true,
			phase: "beforeWrite",
			requires: ["computeStyles"],
			fn({ state }) {
				state.styles.popper.top = "100%";
				state.styles.popper.left = 0;
				state.styles.popper.right = 0;
				state.styles.popper.width = "100%";
				state.styles.popper.maxWidth = "100%";
				state.styles.popper.transform = "";
			},
			effect: ({ state }) => {
				state.elements.popper.style.top = "100%";
				state.elements.popper.style.left = 0;
				state.elements.popper.style.right = 0;
				state.elements.popper.style.width = "100%";
				state.elements.popper.style.maxWidth = "100%";
				state.elements.popper.style.transform = "";
			}
    }]
  },
  content(reference) {
    const id = reference.getAttribute("data-dropdown");
    return document.getElementById(id).innerHTML;
  },
  onMount(instance) {
		instance.reference.setAttribute("aria-expanded", "true");
  },
  onHide(instance) {
		instance.reference.setAttribute("aria-expanded", "false");
  }
});
